{
  "title": "Resumen de Actividad",
  "recapAsOf": "A partir de",
  "viewActivity": "Ver registro completo →",
  "empty": "No hay actividad por lotes en los últimos 2 días hábiles",
  "errorPrefix": "Error:",
  "cards": {
    "batchesRun": {
      "title": "LOTES EJECUTADOS"
    },
    "tradesSent": {
      "title": "OPERACIONES ENVIADAS"
    },
    "portfoliosRebalanced": {
      "title": "CARTERAS REEQUILIBRADAS"
    },
    "failedOrCanceled": {
      "title": "FALLIDAS / CANCELADAS"
    }
  },
  "eventLog": {
    "sectionTitle": "REGISTRO DE EVENTOS",
    "columns": {
      "type": "Tipo",
      "description": "Descripción",
      "metrics": "Métricas",
      "status": "Estado",
      "time": "Hora"
    }
  },
  "status": {
    "COMPLETED": "Completado",
    "SENT": "Enviado",
    "FAILED": "Fallido",
    "CANCELED": "Cancelado"
  },
  "asOfLast48Hours": "Últimas 48 horas",
  "summary": {
    "batchesRunDescription": "En 2 días hábiles",
    "tradesSentDescription": "Enviadas a los custodios",
    "portfoliosRebalancedDescription": "En todos los custodios",
    "failedOrCanceledDescription": "Requieren revisión"
  },
  "events": {
    "portfoliosOptimized_one": "{{count}} cartera optimizada",
    "portfoliosOptimized_other": "{{count}} carteras optimizadas",
    "bulkTradeRunState": "Ejecución de operaciones masivas {{state}}"
  },
  "metrics": {
    "trades_one": "operación",
    "trades_other": "operaciones",
    "portfolios_one": "cartera",
    "portfolios_other": "carteras"
  }
}
